import type { RecipeProposal } from './recipeProposal';

/** Entradas sintéticas fijas para demo y dobles de extracción/transcripción. */
export const RECIPE_FIXTURES: Array<{ id: string; text: string; proposals: RecipeProposal[] }> = [
  { id: 'risotto', text: 'Risotto de setas para cuatro: 320 gramos de arroz carnaroli, medio litro de caldo de verduras y 200 gramos de boletus.', proposals: [{
    name: 'Risotto de setas', servings: 4, lines: [
      { rawText: '320 gramos de arroz carnaroli', ingredientName: 'Arroz carnaroli', qty: 320, unit: 'g', estimated: {} },
      { rawText: 'medio litro de caldo de verduras', ingredientName: 'Caldo de verduras', qty: 0.5, unit: 'l', estimated: {} },
      { rawText: '200 gramos de boletus', ingredientName: 'Boletus', qty: 200, unit: 'g', estimated: {} },
    ],
  }] },
  { id: 'dos-platos', text: 'Dos platos: arroz blanco para dos con 200 gramos de arroz. Y tortilla para uno con dos huevos.', proposals: [
    { name: 'Arroz blanco', servings: 2, lines: [{ rawText: '200 gramos de arroz', ingredientName: 'Arroz', qty: 200, unit: 'g', estimated: {} }] },
    { name: 'Tortilla', servings: 1, lines: [{ rawText: 'dos huevos', ingredientName: 'Huevo', qty: 2, unit: 'pz', estimated: {} }] },
  ] },
  { id: 'subreceta', text: 'Pasta para uno: 100 gramos de pasta y 50 gramos del sofrito base que ya tengo hecho.', proposals: [{
    name: 'Pasta con sofrito', servings: 1, lines: [
      { rawText: '100 gramos de pasta', ingredientName: 'Pasta', qty: 100, unit: 'g', estimated: {} },
      { rawText: '50 gramos del sofrito base que ya tengo hecho', ingredientName: 'Sofrito base', qty: 50, unit: 'g', isSubrecipe: true, estimated: {} },
    ],
  }] },
  { id: 'transcripcion-sin-cantidad', text: 'Salteado de voletus, ponle sal al gusto y un poco de aceite, las cantidades no las sé.', proposals: [{
    name: 'Salteado de boletus', lines: [
      { rawText: 'voletus', ingredientName: 'Boletus', estimated: { qty: true } },
      { rawText: 'sal al gusto', ingredientName: 'Sal', estimated: { qty: true } },
      { rawText: 'un poco de aceite', ingredientName: 'Aceite', estimated: { qty: true } },
    ], notes: ['Faltan las cantidades y el tipo de aceite.'],
  }] },
  { id: 'reposteria', text: 'Galletas: 250 gramos de harina, 100 gramos de azúcar y 125 gramos de mantequilla. Salen diez.', proposals: [{
    name: 'Galletas', servings: 10, lines: [
      { rawText: '250 gramos de harina', ingredientName: 'Harina', qty: 250, unit: 'g', estimated: {} },
      { rawText: '100 gramos de azúcar', ingredientName: 'Azúcar', qty: 100, unit: 'g', estimated: {} },
      { rawText: '125 gramos de mantequilla', ingredientName: 'Mantequilla', qty: 125, unit: 'g', estimated: {} },
    ],
  }] },
];

/**
 * El caso croquetas (revisión con Alex del 12 oct): así lo devolvía el modelo,
 * UNA sola receta con la masa y la porción mezcladas. `ordenarPropuestas` la
 * separa en la preparación y el plato. La demo la usa para simular el dictado
 * cuando se cuentan unas croquetas.
 */
export const CROQUETAS_FIXTURE: { id: string; text: string; proposals: RecipeProposal[] } = {
  id: 'croquetas',
  text: 'Hago una masa de croquetas para unas 400: 4 litros de leche, 400 gramos de mantequilla, 450 de harina, kilo y medio de jamón serrano, una cebolla y media y un poco de nuez moscada. Las vendo en porciones de 8, con alioli, a 9,90.',
  proposals: [{
    name: 'Masa de croquetas', servings: 50, sellingPriceGross: 9.9, lines: [
      { rawText: '4 litros de leche', ingredientName: 'Leche entera', qty: 4, unit: 'l', estimated: {} },
      { rawText: '400 gramos de mantequilla', ingredientName: 'Mantequilla', qty: 400, unit: 'g', estimated: {} },
      { rawText: '450 de harina', ingredientName: 'Harina', qty: 450, unit: 'g', estimated: { unit: true } },
      { rawText: 'kilo y medio de jamón serrano', ingredientName: 'Jamón serrano', qty: 1.5, unit: 'kg', estimated: {} },
      { rawText: 'una cebolla y media', ingredientName: 'Cebolla', qty: 1.5, unit: 'pz', estimated: {} },
      { rawText: 'un poco de nuez moscada', ingredientName: 'Nuez moscada', estimated: { qty: true } },
      { rawText: 'alioli', ingredientName: 'Alioli', estimated: { qty: true } },
    ],
  }],
};
